import React from 'react';

const SendInvite = (props: object) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_10697_9401)">
        <path
          d="M1.63239 9.32685V9.33795H8.3524C8.57072 9.33795 8.74769 9.51493 8.74769 9.73325C8.74769 9.95157 8.57072 10.1286 8.3524 10.1286H1.2371C1.01877 10.1286 0.841797 9.95155 0.841797 9.73325V9.14352C0.841797 9.14153 0.841797 9.13953 0.841797 9.13756V2.61795C0.841797 2.39963 1.01877 2.22266 1.2371 2.22266H11.91C12.1284 2.22266 12.3053 2.39963 12.3053 2.61795V6.96619C12.3053 7.18451 12.1284 7.36149 11.91 7.36149C11.6917 7.36149 11.5147 7.18451 11.5147 6.96619V4.41443L9.08655 6.30301L10.1852 7.20777C10.3537 7.34655 10.3778 7.59569 10.239 7.76419C10.1003 7.93271 9.85111 7.95684 9.68261 7.81803L8.44697 6.80045L6.81624 8.06879C6.6735 8.17983 6.47363 8.17983 6.33088 8.06879L4.70015 6.80045L1.63239 9.32685ZM1.63239 8.30268L4.06057 6.30301L1.63239 4.41443V8.30268ZM6.57356 7.25599L11.5148 3.41286V3.01325H1.63239V3.41286L6.57356 7.25599ZM10.3289 11.1507L10.6423 10.8372C10.7967 10.6829 11.047 10.6829 11.2013 10.8372C11.3557 10.9916 11.3557 11.2419 11.2013 11.3963L10.2131 12.3845C10.0587 12.5389 9.8084 12.5389 9.65405 12.3845L8.66582 11.3963C8.51144 11.2419 8.51144 10.9916 8.66582 10.8372C8.8202 10.6829 9.07049 10.6829 9.22484 10.8372L9.53827 11.1507V10.5238C9.53827 9.21392 10.6001 8.15206 11.91 8.15206C13.2199 8.15206 14.2818 9.21395 14.2818 10.5238C14.2818 11.8337 13.2199 12.8956 11.91 12.8956C11.6917 12.8956 11.5147 12.7186 11.5147 12.5003C11.5147 12.282 11.6917 12.105 11.91 12.105C12.7833 12.105 13.4912 11.3971 13.4912 10.5238C13.4912 9.65057 12.7833 8.94266 11.91 8.94266C11.0368 8.94266 10.3289 9.65057 10.3289 10.5238V11.1507Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10697_9401">
          <rect
            width="13.44"
            height="13.44"
            fill="white"
            transform="translate(0.841797 0.839844)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SendInvite;
